module.exports = __webpack_public_path__ + "static/media/sun.23d1bed7.svg";